import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  GeckoModal,
  GeckoFields,
  GECKO_CONSTS,
  GeckoToastService,
  GeckoModalService,
} from 'ui';
import ContactSelect from 'components/ContactSelect';
import Loader from 'components/Loader';
import ContactCompare from './ContactCompare';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';

class ContactMergeModal extends Component {
  static propTypes = {
    contact_id: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      fetchingContact: false,
      contact: null,
      merge_into: null,
      contactToMerge: null,
    };
  }

  componentDidMount() {
    this.setState({ fetchingContact: true });
    return GeckoRequest.get(`/contact/${this.props.contact_id}`)
      .then((contact) => {
        this.setState({ contact, fetchingContact: false });
      })
      .catch((err) => {
        this.setState({ fetchingContact: false });
        renderError(err);
      });
  }

  fields() {
    return [
      {
        key: 'merge_into',
        label: 'Merge Into',
        description: `Who should we merge this contact with?`,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <ContactSelect disabledContacts={[this.props.contact_id]} />,
      },
    ];
  }

  handleContactSelect(_key, contactId) {
    this.setState({ merge_into: contactId }, () => {
      if (!contactId) {
        return this.setState({ contactToMerge: null });
      }
      return GeckoRequest.get(`/contact/${contactId}`)
        .then((contact) => {
          this.setState({ contactToMerge: contact });
        })
        .catch(renderError);
    });
  }

  buttons() {
    return [
      {
        name: 'Merge',
        icon: 'far fa-arrow-right',
        type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
        handler: () => {
          return GeckoRequest.post('/contact/synchronous_merge', {
            contact1: this.props.contact_id,
            contact2: this.state.merge_into,
          })
            .then(() => {
              new GeckoToastService().success('Contact has been merged');
              new GeckoModalService().close();
            })
            .catch(renderError);
        },
      },
    ];
  }

  render() {
    const modalName = this.state.contact
      ? `Merge ${this.state.contact.full_name}`
      : `Loading...`;
    return (
      <div className="ContactMergeModal">
        <GeckoModal name={modalName} btns={this.buttons()}>
          <Loader isLoading={this.state.fetchingContact}>
            <GeckoFields
              values={this.state}
              fields={this.fields()}
              handler={this.handleContactSelect.bind(this)}
            />
            {this.state.contactToMerge ? (
              <ContactCompare
                contact1={this.state.contact || {}}
                contact2={this.state.contactToMerge || {}}
              />
            ) : null}
          </Loader>
        </GeckoModal>
      </div>
    );
  }
}

export default ContactMergeModal;
